export default "__VITE_ASSET__5a26cedc__"